import { createContext, useState, useContext, useEffect } from 'react';
import { apiLogout } from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData, jwt) => {
    if (!userData || typeof userData !== 'object') {
      console.error('[AuthContext.login] Ungültige userData:', userData);
      throw new Error('Login fehlgeschlagen: Benutzerdaten fehlen');
    }
    if (!jwt || typeof jwt !== 'string') {
      console.error('[AuthContext.login] Ungültiger Token:', jwt);
      throw new Error('Login fehlgeschlagen: Token fehlt');
    }

    setUser(userData);
    setToken(jwt);
    localStorage.setItem('token', jwt);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = async () => {
    if (token) {
      try {
        await apiLogout(token);
      } catch (err) {
        console.error('Logout API error:', err);
      }
    }
    
    setUser(null);
    setToken(null);

    localStorage.removeItem('token');
    localStorage.removeItem('user');

    document.body.dataset.theme = 'dark';
    localStorage.setItem('theme', 'dark');
    
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);